<template>
  <!-- w-32 h-31 -->
  <path d='M3.00003 4.22807L15.5 6.81428L15.5 23.7719L3.00003 21.1857L3.00003 4.22807Z' stroke='white'
        stroke-width='2' />
  <path d='M28.5 4.22807L16 6.81428L16 23.7719L28.5 21.1857L28.5 4.22807Z' stroke='white' stroke-width='2' />
  <path d='M16 28L3.00003 25' stroke='white' stroke-width='2' stroke-linecap='round' />
  <path d='M16 28L29 25' stroke='white' stroke-width='2' stroke-linecap='round' />
</template>
